import React, { useContext } from "react";
import { useState } from "react";
import "../../css_files/Master/AddHSNMaster.css";
import CloseForm from "./CloseForm";
import axios from "axios";
import { toast } from "react-toastify";
import getCookie from "../../api";
import Swal from "sweetalert2";
import axiosInstance from "../../api";
import LoadingScreen from "../Homepage/LoadingScreen";
import { triggerscroll } from "../Homepage/Homepage";

function AddHSNMaster({
  setshowaddform,
  reload,
  setReload,
  triggerupdate,
  hsnupdatedata,
}) {
  const [hsnData, setHsnData] = useState({
    HsnCode: triggerupdate ? hsnupdatedata?.hsnCode : "",
    Description: triggerupdate ? hsnupdatedata?.description : "",
  });
  const [loading, setloading] = useState(false);
  const [message, setMessage] = useState("");
  const { setExpiredSession } = useContext(triggerscroll);

  function handleSubmit(e) {
    e.preventDefault();
    setloading(true);
    if (triggerupdate) {
      const url = `${process.env.REACT_APP_API_URL}/api/v1/HSN/UpdateHSN`;
      axiosInstance
        .post(url, {
          hsnID: hsnupdatedata.id,
          hsnCode: hsnData.HsnCode,
          description: hsnData.Description,
        })
        .then((res) => {
          toast.success(res.data.message, {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((err) => {
          if (err.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: err.response.data.error,
              icon: "error",
            });
          } else {
            toast.error("Failed to Update", {
              position: "bottom-center",
              theme: "dark",
            });
          }
          console.log(err);
          setloading(false);
        });
    } else {
      const url = `${process.env.REACT_APP_API_URL}/api/v1/HSN`;
      axiosInstance
        .post(url, hsnData)
        .then((response) => {
          toast.success("Record Added Successfully", {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((error) => {
          console.error("Error adding hsn data:", error);
          if (error.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: error.response.data.error,
              icon: "error",
            });
          } else {
            toast.error("Failed to Add Record", {
              position: "bottom-center",
              theme: "dark",
            });
          }
          setloading(false);
        });
    }
  }

  return (
    <form className="add-hsn-master" onSubmit={handleSubmit}>
      <blockquote>
        <label>
          HSN Code{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <input
          type="number"
          placeholder="Enter HSN Code (minimum 4 to maximum 8 digits)"
          value={hsnData.HsnCode}
          onChange={(e) => setHsnData({ ...hsnData, HsnCode: e.target.value })}
          onInput={(e) => {
            e.target.value = e.target.value.slice(0, 8);
            axiosInstance
              .get(
                `${process.env.REACT_APP_API_URL}/api/v1/HSN/GetHSNByIdOrCode?HsnCode=${e.target.value}`
              )
              .then(() => {
                setMessage("HSN Code Already Exists");
              })
              .catch((error) => {
                setMessage("");
              });
          }}
          required
        />
        <span style={{ color: "red" }}>{message}</span>
      </blockquote>

      <blockquote>
        <label>Description</label>
        <textarea
          rows={5}
          placeholder="Enter HSN Description (Maximum 400 Characters)"
          value={hsnData.Description}
          onChange={(e) =>
            setHsnData({ ...hsnData, Description: e.target.value })
          }
          onInput={(e) => {
            e.target.value = e.target.value.slice(0, 400);
          }}
        ></textarea>
      </blockquote>

      <button type="submit">{triggerupdate ? "Update" : "Add"} </button>
      <CloseForm close={setshowaddform} />
      {loading && <LoadingScreen />}
    </form>
  );
}

export default AddHSNMaster;
